// ============================================================
// FILE: BookingDetail.js
// LOCATION: C:\gardenmarket\web\src\pages\gardener\BookingDetail.js
// ============================================================
// PURPOSE:
//   Standalone full-page wrapper around BookingDetailContent.js —
//   kept for direct links even though MyBookings.js now embeds
//   the same content in its master-detail pane.
//
// ROUTE: /gardener/booking/:id
// ============================================================

import { useParams } from 'react-router-dom';
import BookingDetailContent from './BookingDetailContent';

export default function BookingDetail() {
    const { id } = useParams();
    return <BookingDetailContent jobId={id} embedded={false} />;
}
